// Yandex Metrika - replaces vue-yandex-metrika 1.8.3 (Vue 2 only) and does what it did with the app's settings:
// loads tag.js (in every environment), then in production creates the counter (window.yaCounter<id>) and sends a hit
// for every route change to another path. Visitor params (setMetrikaUserParams) are sent once the counter exists.
const ID = 99187843
const OPTIONS = {
  clickmap: true,
  trackLinks: true,
  accurateTrackBounce: true,
  webvisor: false
}

let counter = null
let pendingUserParams = null

// the layout may mount before tag.js has loaded: then the params wait for the counter (outside production: dropped)
export const setMetrikaUserParams = (params) => {
  if(counter) counter.userParams(params)
  else pendingUserParams = params
}

export const installMetrika = (router) => {
  const script = document.createElement('script')
  script.async = true
  script.charset = 'utf-8'
  script.src = 'https://mc.yandex.ru/metrika/tag.js'
  script.onload = () => {
    if(process.env.NODE_ENV !== 'production') {
      console.warn('[metrika] Tracking is disabled, because the environment is not "production"')
      pendingUserParams = null
      return
    }
    if(!window.Ya?.Metrika2) return // tag.js was replaced by a stub (ad blocker / privacy extension)
    const metrika = counter = new window.Ya.Metrika2({ id: ID, ...OPTIONS })
    window[`yaCounter${ID}`] = metrika
    if(pendingUserParams) {
      metrika.userParams(pendingUserParams)
      pendingUserParams = null
    }
    router.afterEach((to, from) => {
      if(to.path === from.path) return
      metrika.hit(to.path, { referer: from.path })
    })
  }
  ;(document.head || document.getElementsByTagName('head')[0]).appendChild(script)
}
